<template>
  <div class="body">
    <el-container>
      <UsersAside @toggle="toggle($event)" />
      <el-main>
        <el-card>
          <template slot="header"> اضافة مستخدم جديد </template>
          <el-form
            :rules="rules"
            ref="NewUser"
            :model="form"
            label-width="120px"
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="الاسم" prop="name">
                  <el-input
                    class="input1"
                    @focus="$event.target.select()"
                    v-model="form.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="كلمة المرور" prop="password">
                  <el-input
                    class="input2"
                    type="password"
                    :show-password="true"
                    suffix-icon="el-icon-lock"
                    @focus="$event.target.select()"
                    v-model="form.password"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="تاكيد كلمة المرور" prop="confirmPassword">
                  <el-input
                    class="input2"
                    type="password"
                    :show-password="true"
                    suffix-icon="el-icon-lock"
                    @focus="$event.target.select()"
                    v-model="form.confirmPassword"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="5" :lg="5" :md="12" :sm="12">
                <el-form-item label="الفرع" prop="branch_id">
                  <el-select
                    id="input3"
                    class="input3"
                    v-model="form.branch_id"
                    clearable
                    placeholder="الفرع"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(branch, i) in branchList"
                      :key="'br' + i"
                      :label="branch.name + ' - ' + branch.address"
                      :value="branch.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="5" :lg="5" :md="24" :sm="24">
                <el-form-item label="الصلاحيه" prop="role_id">
                  <el-select
                    id="input4"
                    class="input4"
                    v-model="role_id"
                    clearable
                    @change="addrole"
                    placeholder="الصلاحيه"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(role, i) in rolesList"
                      :key="'br' + i"
                      :label="role.name"
                      :value="role.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <el-button class="mt-5" type="warning" @click="addUser()">
                  تسجيل</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import UsersAside from "@/components/UsersAside.vue";
import axiosApi from "@/plugins/axios.js";
export default {
  components: { UsersAside },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("من فضلك اكد كلمة المرور"));
      } else if (value !== this.form.password) {
        callback(new Error("كملة المرور غير متطابقه"));
      } else {
        callback();
      }
    };
    return {
      activeSide: true,
      isLoading: false,
      form: {
        name: "",
        password: "",
        confirmPassword: "",
        roles: [],
        branch_id: "",
      },
      rules: {
        name: [
          { required: true, message: "حدد اسم المستخدم", trigger: "blur" },
        ],
        password: [
          { required: true, message: "حدد الرقم السري", trigger: "blur" },
        ],
        confirmPassword: [{ validator: validatePass2, trigger: "blur" }],
        roles: [{ required: true, message: "حدد الصلاحية", trigger: "blur" }],
        branch_id: [{ required: true, message: "حدد الفرع", trigger: "blur" }],
      },
      role_id: "",
      rolesList: [],
      branchList: [],
    };
  },
  methods: {
    toggle(active) {
      this.activeSide = active;
    },
    addUser() {
      this.$refs["NewUser"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تسجيل المستخدم",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .post("users", this.form)
            .then(() => {
              this.$refs["NewUser"].resetFields();
              this.role_id = ""
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات المستخدم بنجاح",
                type: "success",
                duration: 1500,
              });
            })
            .catch((err) => {
              this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من بيانات المستخدم",
                  duration: 1500,
                });
              console.log(err);
            })
            .finally(()=>{
              loading.close();
              this.isLoading = false;
            });
        } else {
          console.log("error");
          return false;
        }
      });
    },
    addrole() {
      this.form.roles = [];
      this.form.roles.push(this.role_id)
    }
  },
  mounted() {
    axiosApi.get("roles").then((res) => {
      this.rolesList = res.data.data;
    });
    axiosApi.get("branches").then((res) => {
      this.branchList = res.data;
    });
  },
};
</script>
